import { useMutation } from '@tanstack/react-query'

import type { ApiErrorResponse, UseAppMutationOptions } from '../../../types'
import { updateOneLocation } from '../location.api'
import {
  invalidateAllLocations,
  invalidateLocationOne,
  locationsQueryKeys
} from '../location.queryKeys'
import type { LocationUpdateSchema } from '../types/Location.update.schema'

export const useUpdateOneLocation = (
  mutationOptions?: UseAppMutationOptions<
    {},
    ApiErrorResponse,
    LocationUpdateSchema
  >
) => {
  return useMutation<{}, ApiErrorResponse, LocationUpdateSchema>({
    ...mutationOptions,
    mutationKey: locationsQueryKeys.update(),
    mutationFn: (requestOptions: LocationUpdateSchema) =>
      updateOneLocation(requestOptions),
    onSuccess: (data, variables, ...args) => {
      if (mutationOptions?.onSuccess) {
        mutationOptions.onSuccess(data, variables, ...args)
      }

      invalidateAllLocations()
      invalidateLocationOne({
        pathParams: {
          id: Number(variables.pathParams.id)
        }
      })
    }
  })
}
